import { SubscriptionMembershipPreviousDTO } from "@gymflow/types";
import { useClubSettings } from "apps/portal/src/providers";
import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";

import {
  getBillingText,
  getMembershipTypeText,
  getTillDateText,
} from "../../utils/getText";

type MembershipHistoryItemProps = {
  itemInfo: SubscriptionMembershipPreviousDTO;
};

export const MembershipHistoryItem = ({
  itemInfo: { name, startDate, endDate, endContractDate, termsConditionsUrl },
  itemInfo,
}: MembershipHistoryItemProps) => {
  const { defaultCurrency } = useClubSettings();
  const { t } = useTranslation();

  return (
    <div className="flex w-full max-w-lg flex-row gap-2.5">
      <div className="flex flex-col items-center gap-1 px-1 pt-1">
        <div className="size-3 rounded-full bg-gray-300 dark:bg-gray-700" />
        <div className="w-px flex-1 rounded-full bg-gray-300 dark:bg-gray-700" />
      </div>
      <div className="flex flex-1 flex-col gap-2 last:mb-6">
        <div className="text-sm font-semibold text-gray-500 dark:text-gray-400">
          {`${DateTime.fromISO(startDate).toLocaleString(DateTime.DATE_MED)} - ${DateTime.fromISO(endDate).toLocaleString(DateTime.DATE_MED)}`}
        </div>
        <div className="bg-gray-0 shadow-xs flex flex-col gap-3 rounded-xl border border-gray-200 p-3 dark:border-gray-600 dark:bg-gray-950">
          <div className="dark:text-gray-25 text-sm font-bold text-gray-950">
            {name}
          </div>
          <div className="flex flex-wrap items-center gap-2 self-stretch">
            <div className="text-xs font-medium text-gray-500 dark:text-gray-400">
              {getBillingText(itemInfo, defaultCurrency)}
            </div>
            <div className="size-1.5 rounded-full bg-gray-300 dark:bg-gray-700" />
            <div className="text-xs font-medium text-gray-500 dark:text-gray-400">
              {getMembershipTypeText(itemInfo)}
            </div>
            {endContractDate && (
              <>
                <div className="size-1.5 rounded-full bg-gray-300 dark:bg-gray-700" />
                <div className="text-xs font-medium text-gray-500 dark:text-gray-400">
                  {getTillDateText(itemInfo)}
                </div>
              </>
            )}
            <div className="size-1.5 rounded-full bg-gray-300 dark:bg-gray-700" />
            <a
              className="text-secondary-500 hover:text-secondary-700 active:text-secondary-900 min-w-fit text-xs font-semibold"
              href={termsConditionsUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t(
                "page.hostedPagesProfileMembershipHistory.membershipHistoryItem.viewTerms",
              )}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
